import {getStoredSession} from './supabase-auth.js';

const fromWindow = key => {
    if (typeof window === 'undefined' || !window.__BITBYTE_CLOUDFLARE__) return null;
    return window.__BITBYTE_CLOUDFLARE__[key] || null;
};

const fromEnv = key => {
    if (typeof process === 'undefined' || !process.env) return null;
    return process.env[key] || null;
};

const fromMeta = key => {
    if (typeof document === 'undefined') return null;
    const node = document.querySelector(`meta[name="${key}"]`);
    return node ? node.getAttribute('content') : null;
};

const pick = (...values) => values.find(value => typeof value === 'string' && value.trim().length > 0) || null;

const cloudflareConfig = {
    projectHost: pick(
        fromWindow('projectHost'),
        fromEnv('BITBYTE_PROJECT_HOST'),
        fromMeta('bitbyte-project-host'),
        'https://bitbyteprojectsapi.namrahaijaz87.workers.dev/projects'
    ),
    assetHost: pick(
        fromWindow('assetHost'),
        fromEnv('BITBYTE_ASSET_HOST'),
        fromMeta('bitbyte-asset-host'),
        'https://bitbyte-34w.pages.dev'
    ),
    cloudHost: pick(
        fromWindow('cloudHost'),
        fromEnv('BITBYTE_CLOUD_HOST'),
        fromMeta('bitbyte-cloud-host'),
        null
    )
};

const getSupabaseAccessToken = () => {
    const session = getStoredSession();
    return session && session.access_token ? session.access_token : null;
};

export {
    cloudflareConfig,
    getSupabaseAccessToken
};
